import * as React from 'react';
import Avatar from "material-ui/Avatar";
import ColorUtil from 'diy/util/color';
import {autoprefixer} from "diy/material-ui/autoprefixer";
import CheckIcon from 'material-ui/svg-icons/navigation/check';

export interface ColorSwatchItemProps {
    checkColor?: string;
    checked?: boolean;
    color?: string;
    className?: string;
    size?: number;
}

interface ColorSwatchItemState {

}

export class ColorSwatchItem extends React.Component<ColorSwatchItemProps, ColorSwatchItemState> {
    static defaultProps = {
        size: 30
    };

    render() {
        let color = this.props.color;
        let checkColor = this.props.checkColor;
        let isChecked = this.props.checked;

        if (!checkColor && isChecked) {
            let rgbValue = ColorUtil.hex2rgb(color);

            if (ColorUtil.computePerceivedLightness(rgbValue) > .686) {
                checkColor = "black";
            } else {
                checkColor = "white";
            }
        }

        return <Avatar
            icon={isChecked ? <CheckIcon style={{margin: 0}} /> : null}
            backgroundColor={color}
            color={checkColor}
            style={autoprefixer({
                boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden'
            })}
            size={this.props.size}
            className={this.props.className}
        >
        {this.props.children}
        </Avatar>;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/common/ColorSwatchItem.tsx
 **/